import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Illustration } from './common/Illustration';

const PRESETS: Record<number, { title: string; message: string; illustrationContext: string }> = {
  404: { title: 'Page not found', message: "The page you're looking for doesn't exist or may have moved.", illustrationContext: 'error.404' },
  500: { title: 'Something went wrong', message: 'An unexpected error occurred. Please try again.', illustrationContext: 'error.500' },
};

export function ErrorPage({ code = 404 }: { code?: number }) {
  const navigate = useNavigate();
  const preset = PRESETS[code] ?? PRESETS[404];

  return (
    <section className="adaptive-page error-page">
      <div className="error-card">
        <Illustration context={preset.illustrationContext} size="xl" className="error-illustration" />
        <span className="error-code" aria-hidden="true">{code}</span>
        <h1>{preset.title}</h1>
        <p>{preset.message}</p>
        <div className="error-actions">
          <button type="button" className="secondary-action" onClick={() => navigate(-1)}>
            <ArrowLeft size={17} aria-hidden="true" /> Go back
          </button>
          <button type="button" className="primary-action" onClick={() => navigate('/')}>
            <Home size={17} aria-hidden="true" /> Home
          </button>
        </div>
      </div>
    </section>
  );
}
